export const enUS = {
  // Nav
  dashboard: 'Dashboard',
  simulations: 'Simulations',
  assessment: 'Assessment',
  organization: 'Organization',
  history: 'Reports',
  newOrganization: 'New Organization',
  profile: 'Profile',
  settings: 'Settings',
  logout: 'Logout',
  user: 'User',
  menu: 'Menu',

  // Search
  search: 'Search',
  searchPlaceholder: 'Search in SecureCoop...',
  pressEnterToSearch: 'Press Enter to search',
  searchSuggestions: ['phishing', 'social engineering', 'dashboard', 'history', 'assessment', 'organization', 'brute force', 'report'],

  // Notifications
  notifications: 'Notifications',
  noNotifications: 'No notifications',
  unread: 'unread',
  unreadPlural: 'unread',

  // Time
  now: 'now',
  minutesAgo: '{n} min ago',
  hoursAgo: '{n}h ago',
  daysAgo: '{n} day ago',
  daysAgoPlural: '{n} days ago',

  // Settings
  preferences: 'Interface preferences',
  themeMode: 'Theme mode',
  lightTheme: 'Light Mode',
  darkTheme: 'Dark Mode',
  language: 'Language',
  interfaceAnimations: 'Interface animations',
  animationDesc: 'Transitions and visual effects',
  notificationsSetting: 'Notifications',
  notificationsDesc: 'System alerts and warnings',
  demoTools: 'Demo tools',
  demoToolsDesc: 'Useful for resetting data during presentations.',
  resetSimulationData: 'Reset Simulation Data',
  confirmReset: 'Confirm data reset?',
  close: 'Close',
  attention: 'Warning',

  // Profile modal
  manageInfo: 'Manage your information',
  profilePhoto: 'Profile photo',
  uploadNewPhoto: 'Upload new photo',
  removePhoto: 'Remove photo',
  name: 'Name',
  email: 'Email',
  yourName: 'Your name',
  emailReadonly: 'Email cannot be changed',
  accountSecurity: 'Account security',
  changePassword: 'Change password (optional)',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmPassword: 'Confirm new password',
  cancel: 'Cancel',
  save: 'Save',
  saving: 'Saving...',
  photoPreview: 'Photo preview',
  errorCurrentPassword: 'Enter current password to change it.',
  errorPasswordsMismatch: 'Passwords do not match.',
  errorPasswordMin: 'New password must be at least 6 characters.',
  successPhotoUpdated: 'Photo updated successfully.',
  successProfileUpdated: 'Profile updated successfully.',
  successProfilePasswordNote: 'Profile updated. Password change requires backend support.',
  errorSaving: 'Error saving.',

  // Auth
  signIn: 'Sign In',
  signInProgress: 'Signing in...',
  createAccount: 'Create account',
  signUp: 'Register',
  signUpProgress: 'Registering...',
  noAccount: "Don't have an account?",
  hasAccount: 'Already have an account?',
  signUpLink: 'Sign up',
  signInLink: 'Sign in',
  password: 'Password',
  minChars: 'Minimum 6 characters',
  securityPlatform: 'Security Awareness Platform',

  // Home
  welcome: 'Manage your organization\'s security',
  welcomeDesc: 'Simulate attacks, identify risks and strengthen your team with real data.',
  accessDashboard: 'Access Dashboard',
  createOrganization: 'Create Organization',

  // Dashboard
  dashboardTitle: 'Security Awareness Dashboard',
  dashboardSubtitle: 'Overview of your organization\'s security and awareness',
  securityOverview: 'Security Overview',
  humanRiskScore: 'Human Risk Score',
  simulationsExecuted: 'Simulations Executed',
  vulnerabilitiesDetected: 'Vulnerabilities Detected',
  riskAnalysis: 'Risk Analysis',
  phishingRisk: 'Phishing Risk',
  socialEngineeringRisk: 'Social Engineering Risk',
  authorityFraudRisk: 'Authority Fraud Risk',
  recentActivity: 'Recent Activity',
  recentActivitySubtitle: 'Latest simulation activities',
  quickActions: 'Quick Actions',
  quickActionsSubtitle: 'Quick access to simulations',
  startPhishingSim: 'Start Phishing Simulation',
  startSocialEngineeringSim: 'Start Social Engineering Simulation',
  startBruteForceSim: 'Start Brute Force Simulation',
  startSocialEngineeringChat: 'Start Social Engineering Chat',
  noRecentActivity: 'No recent activity',
  runSimulationsToSee: 'Run simulations to see activities here.',
  goToSimulations: 'Go to Simulations',
  criticalVulnerabilities: 'Critical Vulnerabilities',
  noCriticalVulns: 'No critical vulnerabilities at this time.',
  recentAssessments: 'Recent Assessments',
  lastAssessment: 'Last assessment',
  none: 'None',
  viewReport: 'View report',
  noAssessments: 'No assessments completed.',

  // Simulations
  attackSimulations: 'Attack Simulations',
  simulationsSubtitle: 'Run simulations to understand how common attacks work and track your risk profile.',
  riskOverview: 'Security Risk Overview',
  riskOverviewSubtitle: 'Summary of human risk based on simulations performed',
  runSocialEngineeringForScore: 'Run social engineering simulations to calculate your score',
  availableSimulations: 'Available simulations',
  phishing: 'Phishing',
  phishingDesc: 'Simulates a phishing email attack',
  socialEngineering: 'Social Engineering',
  socialEngineeringDesc: 'Simulates social engineering scenarios in chat format',
  bruteForce: 'Brute Force',
  bruteForceDesc: 'Simulates brute force access attempts and evaluates account lockout, rate limiting and weak-password exposure.',
  lastRun: 'Last run',
  startSimulation: 'Start Simulation',
  starting: 'Starting...',
  simulationComplete: 'Simulation complete',
  phishingSimComplete: 'Phishing scenario demo completed',
  socialEngineeringSimComplete: 'Social engineering simulation completed',
  bruteForceSimComplete: 'Brute force simulation completed',
  simulationDetails: 'Simulation details',
  simulationOf: 'Simulation of',
  executedAt: 'Executed at',
  by: 'by',
  timeline: 'Timeline',
  timelineTimesIllustrative: 'Step timestamps are illustrative to represent the educational simulation sequence.',
  bruteForceResultTitle: 'Authentication controls result',
  controlsStatus: 'Controls status',
  simulatedAttempts: 'Simulated attempts',
  blockThreshold: 'Block threshold',
  bruteForceOutcomeBlocked: 'Blocked',
  bruteForceOutcomeRateLimited: 'Rate limited',
  bruteForceOutcomeSuccess: 'Simulated compromise',
  bruteForceOutcomeIndeterminate: 'Indeterminate',
  bruteForceLabTitle: 'Brute Force Lab',
  bruteForceLabSubtitle: 'Test a sample password and understand risk, crack time and attempt behavior.',
  bruteForceLabHowItWorks: 'How it works',
  bruteForceLabHowItWorksSubtitle: 'The password is evaluated locally in your browser and only metrics are saved to history.',
  bruteForceLabWarning: 'Use a fictional training password only. Never provide a real password.',
  bruteForceLabPasswordInputLabel: 'Test password',
  bruteForceLabPasswordInputPlaceholder: 'Example: Coop@123',
  bruteForceLabEstimatedResult: 'Estimated lab result',
  bruteForceLabEstimatedResultSubtitle: 'Educational estimations to support security awareness.',
  bruteForceLabSavedToHistory: 'Result saved to simulation history.',
  passwordStrengthLevel: 'Password strength level',
  passwordEntropyBits: 'Entropy (bits)',
  timeToCrackRateLimited: 'Time to crack (with rate limiting)',
  timeToCrackNoRateLimit: 'Time to crack (without rate limiting)',
  timeToCrackOfflineLeak: 'Time to crack (offline leak)',
  simulatedOutcome: 'Simulated outcome',
  strengthLOW: 'Weak',
  strengthMEDIUM: 'Medium',
  strengthHIGH: 'Strong',
  strengthVERY_HIGH: 'Very strong',
  outcomeBLOCKED: 'Blocked',
  outcomeRATE_LIMITED: 'Rate limited',
  outcomeSUCCESS: 'Compromised',
  outcomeINDETERMINATE: 'Indeterminate',
  lessThanSecond: '< 1s',
  moreThanCentury: '> 100 years',
  moreThanMonth: '> 30 days',
  runningSimulation: 'Running simulation...',
  errorRunningBruteForceLab: 'Failed to run brute force lab.',
  bruteForcePolicyBlocked: 'Account lockout and attempt monitoring prevented unauthorized access.',
  bruteForcePolicyRateLimited: 'Rate limiting reduced the attempt volume, but no full account lockout occurred.',
  bruteForcePolicySuccess: 'The password is vulnerable in scenarios without effective controls.',
  bruteForcePolicyIndeterminate: 'Partial controls were detected, but residual risk still requires hardening.',
  bruteForceOverlayTitle: 'Attack simulation in progress',
  bruteForceOverlaySubtitle: 'Educational visual demonstration of automated attempts.',
  bruteForceOverlayProgress: 'Simulation progress',
  bruteForceOverlayHeaderLine: '[SecureCoop] Initializing brute force simulation engine...',
  bruteForceOverlayInitLine: '> Connecting to simulated authentication endpoint...',
  bruteForceOverlayAttemptLine: '> Attempt #{n}: validating candidate credential',
  bruteForceOverlayRateLimitLine: '> Control detected: system rate limiting enabled',
  bruteForceOverlayLockoutLine: '> Control detected: temporary account lockout applied',
  bruteForceOverlayCompromisedLine: '> Warning: simulated scenario indicates credential compromise',
  bruteForceOverlayIndeterminateLine: '> Partial outcome: controls present, residual risk still relevant',
  bruteForceOverlayFinishedLine: '> Finishing simulation and consolidating metrics...',
  overlayStatusTrying: 'Trying combinations',
  overlayStatusRateLimited: 'Rate limiting detected',
  overlayStatusBlocked: 'Lockout detected',
  overlayStatusCompromised: 'Simulated compromise',
  overlayStatusAnalyzing: 'Consolidating result',
  bruteForceEventRecon: 'Authentication service and policy reconnaissance',
  bruteForceEventReconImpact: 'Exposed surface mapping for automated attempts',
  bruteForceEventAttempts: 'Automated execution of {n} simulated attempts',
  bruteForceEventAttemptsImpact: 'Attempt volume consistent with brute force behavior',
  bruteForceEventControlBlocked: 'Control applied: temporary account lockout',
  bruteForceEventControlRateLimited: 'Control applied: rate limiting enforced',
  bruteForceEventControlWeak: 'Weak controls: no effective lockout/rate limiting',
  bruteForceEventControlPartial: 'Partial controls detected during simulation',
  bruteForceEventControlImpact: 'Assessment of authentication defense mechanisms',
  bruteForceEventOutcomeBlocked: 'Final outcome: simulated attack blocked',
  bruteForceEventOutcomeRateLimited: 'Final outcome: attack reduced by rate limiting',
  bruteForceEventOutcomeCompromised: 'Final outcome: simulated credential compromise',
  bruteForceEventOutcomeIndeterminate: 'Final outcome: residual risk is indeterminate',
  bruteForceEventOutcomeImpact: 'Consolidated impact of the simulated scenario',
  bruteForceDetailsDefaultSummary: 'Summary unavailable for this run. Check timeline events.',
  estimatedCrackTime: 'Estimated crack time',
  simulationHistory: 'Simulation History',
  simulationHistorySubtitle: 'All simulations run in this organization',
  noSimulationsYet: 'No simulations run yet',
  runFirstSimulation: 'Run your first simulation to assess human risk.',
  viewSimulations: 'View simulations',
  type: 'Type',
  date: 'Date',
  executedBy: 'Executed by',
  action: 'Action',
  viewDetails: 'View details',
  backToSimulations: 'Back to Simulations',

  // Simulation intros - use array index
  phishingSimIntro: 'Phishing Simulation',
  socialEngineeringSimIntro: 'Social Engineering Simulation',
  understandBeforeStart: 'Understand how it works before starting.',
  whatWillBeSimulated: 'What will be simulated',
  phishingIntroSubtitle: 'Training for malicious email recognition',
  socialEngineeringIntroSubtitle: 'Social engineering training with guided conversation',
  prerequisites: 'Prerequisites',
  phishingPrerequisitesText: 'Use only an email you own and run this in a training environment.',
  socialEngineeringPrerequisitesText: 'Set aside a few minutes to complete the scenario and answer each step carefully.',
  phishingSimDesc: 'This simulation sends a phishing email to the address you provide. The system will track your actions to assess your security awareness.',
  phishingSimPoints: [
    'The system records whether the email was opened',
    'The system records whether the email link was clicked',
    'At the end, you will see an educational result showing what could happen in a real attack',
  ],
  socialEngineeringSimDesc: 'This simulation presents a chat-style conversation with an attacker trying to obtain sensitive information or induce dangerous actions through psychological manipulation.',
  socialEngineeringSimPoints: [
    'You will see attacker messages (e.g., IT Support, HR, Manager)',
    'For each message, choose how you would respond in a real situation',
    'The attacker reacts to your responses, creating different paths',
    'At the end, you receive training feedback on what could happen in a real attack',
  ],
  phishingAttention: 'Warning: Only use your own email and consciously authorize the simulation. This tool is for training and awareness.',
  socialEngineeringScenarios: 'Scenarios include: Fake IT Support, HR requesting data validation, and manager requesting urgent action. Less obvious responses may lead to different conversation paths.',
  startSimulationBtn: 'Start Simulation',
  back: 'Back',

  // Phishing Manual
  manualPhishingSim: 'Manual Phishing Simulation',
  manualPhishingDesc: 'Send a phishing test email to your own address to assess your awareness.',
  sendVerificationCode: 'Send verification code',
  verificationCodeSent: 'Code sent! Check your email.',
  enterVerificationCode: 'Enter the 6-digit code',
  verifyCode: 'Verify code',
  codeVerified: 'Email verified. You can now send the simulation.',
  sendSimulation: 'Send simulation',
  bypassVerification: 'Send without verification (authorized user)',
  sendDirectly: 'Send directly',
  phishingAttentionManual: 'This simulation should only be used for personal testing. For corporate use or simulations with real employees, please contact us.',
  yourEmail: 'Your email',
  emailPlaceholder: 'you@email.com',
  confirmEmailAuth: 'I confirm that this email belongs to me and authorize the phishing simulation to be sent.',
  sendEmail: 'Send Email',
  sending: 'Sending...',
  emailSentSuccess: 'Email sent successfully!',
  emailSentDesc: 'A simulation email has been sent to {email}. Check your inbox and click the link to complete the simulation and see the result.',
  mustConfirmEmail: 'You must confirm that the email is yours and authorize the simulation.',

  // Phishing Result
  phishingResultTitle: 'Phishing Simulation Result',
  emailSent: 'Email sent',
  emailOpened: 'Email opened',
  linkClicked: 'Link clicked',
  securitySimulationNotice: 'This was a security simulation',
  phishingResultDesc: 'The email you received was part of an awareness test. In a real phishing attack, clicking the link and entering your credentials could allow criminals to steal them and access your accounts. Always verify the sender and URL before providing sensitive data.',
  thanksForParticipating: 'Thank you for participating in the security simulation.',
  invalidLink: 'Invalid link',

  // Social Engineering Chat
  chatSimTitle: 'Chat Simulation – Social Engineering',
  chatSimDesc: 'Simulate a conversation with an attacker. Choose your responses and see the training result at the end.',
  selectScenario: 'Select a scenario',
  noScenariosAvailable: 'No scenarios available',
  noScenariosDesc: 'There are no chat scenarios available at this time.',
  attacker: 'Attacker',
  startConversation: 'Start conversation',
  trainingResult: 'Training result',
  safeChoice: 'Safe choice',
  highRisk: 'High risk',
  yourChoices: 'Your choices',
  newConversation: 'New conversation',
  howWouldYouRespond: 'How would you respond?',

  // Assessment
  securityAssessment: 'Security Assessment',
  assessmentDesc: 'Answer the questions to get your score and identify vulnerabilities.',
  weight: 'Weight',
  category: 'Category',
  general: 'General',
  yes: 'Yes',
  no: 'No',
  submitAssessment: 'Submit Assessment',
  submitting: 'Submitting...',

  // History
  assessmentHistory: 'Assessment History',
  assessmentHistoryDesc: 'All security assessments conducted by the organization.',
  noAssessmentsFound: 'No assessments found.',
  runAssessment: 'Run Assessment',
  riskLevel: 'Risk Level',
  vulnerabilities: 'Vulnerabilities',

  // Report
  securityReport: 'Security Report',
  assessmentOf: 'Assessment of',
  backToDashboard: 'Back to Dashboard',
  securityScore: 'Security Score',
  of100Points: 'out of 100 points',
  vulnerabilitiesDetectedTitle: 'Vulnerabilities Detected',
  recommendation: 'Recommendation',
  noCriticalVulnerabilities: 'No critical vulnerabilities',
  congratsNoVulns: 'Congratulations! This assessment did not identify critical vulnerabilities.',
  securityRecommendations: 'Security Recommendations',
  reportRecommendations: [
    'Conduct security assessments periodically (recommended: quarterly)',
    'Train employees on Phishing and Social Engineering',
    'Implement MFA on all critical access points',
    'Keep systems and antivirus updated',
    'Monitor and audit system access',
    'Develop an incident response plan',
  ],
  reportNotFound: 'Report not found.',

  // Organization
  organizationData: 'Organization Data',
  organizationUsers: 'Organization Users',
  bypassPermission: 'Send simulation without verification',
  grantingBypass: 'Granting...',
  revokingBypass: 'Revoking...',
  userRole: 'Role',
  bypassAlways: 'always',
  employeesCount: 'Number of employees',
  hasItTeam: 'Has IT team',
  hasSecurityPolicy: 'Has security policy',
  createOrgTitle: 'Create Organization',
  createOrgDesc: 'Register your cooperative or organization to start assessments.',
  organizationName: 'Organization name',
  orgPlaceholder: 'e.g.: ABC Cooperative',

  // Risk labels
  low: 'LOW',
  medium: 'MEDIUM',
  high: 'HIGH',
  critical: 'CRITICAL',

  // Relative date
  today: 'Today',
  yesterday: 'Yesterday',

  // Search
  noResultsFound: 'No results found',

  // History table
  score: 'Score',

  // Report severity
  severityLow: 'Low',
  severityMedium: 'Medium',
  severityHigh: 'High',
  severityCritical: 'Critical',

  // Notification demo messages
  notifSimulationComplete: 'Simulation completed',
  notifPhishingClicked: 'User clicked the phishing link',
  notifSEDataShared: 'Sensitive data shared in social engineering simulation',
  notifVulnerabilityDetected: 'New vulnerability detected',
  notifRiskUpdated: 'Security score updated',

  // Activity timeline (simulation steps from backend)
  activityStepBrute1: 'Authentication system recognition',
  activityStepBrute2: 'Multiple password attempts sent',
  activityStepBrute3: 'Blocking detection or rate limiting',
  activityStepBrute4: 'Simulation result based on controls',
  activityStepPhishing1: 'Fake email sent to employees',
  activityStepPhishing2: 'Employee clicks malicious link',
  activityStepPhishing3: 'Fake login page captures credentials',
  activityStepPhishing4: 'Attacker gains system access',
  activityStepSE1: 'Attacker identifies target and context',
  activityStepSE2: 'Initial contact posing as support',
  activityStepSE3: 'Persuasion to reveal sensitive information',
  activityStepSE4: 'Attacker uses information for unauthorized access',

  // Critical vulnerability card
  vulnCriticalRiskPrefix: 'Critical Risk: ',
  vulnRecommendationDefault: 'Implement the necessary measures to meet this security requirement.',
  vulnQuestionMFA: 'Does the organization use MFA (Multi-Factor) authentication?',
  vulnQuestionLogin: 'Is login monitored?',
  vulnQuestionSensitiveData: 'Is access to sensitive data controlled?',
  vulnQuestionIncidents: 'Is there an incident response process?',
  vulnQuestionEncryption: 'Is sensitive data encrypted?',
  vulnQuestionVPN: 'Is remote access protected with VPN?',
};
